import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useCallback } from "react";

export interface HiringQualificationRanking {
  qualificationRanking: string[];
  getHighestRankingQualification: (qualifications: string[]) => string | undefined;
  sortQualificationsByRanking: (qualifications: string[]) => string[];
}

export function useHiringQualificationRanking(): HiringQualificationRanking {
  const qualificationRanking = useCbhFlag(CbhFeatureFlag.HIRING_QUALIFICATION_RANKING, {
    defaultValue: [
      "Lead Teacher",
      "Substitute Teacher",
      "Early Education Teacher",
      "Early Education Aide",
      "Teacher Assistant",
      "Paraprofessional",
      "RN Supervisor",
      "RN",
      "LVN / LPN Supervisor",
      "LVN",
      "LPN",
      "LVN / LPN",
      "CNA",
      "CHHA",
      "HHA",
      "CAREGIVER",
      "NURSE",
      "Janitor",
    ],
  });

  const getHighestRankingQualification = useCallback(
    (qualifications: string[]) => {
      return qualificationRanking.find((rankingQualification) =>
        qualifications.includes(rankingQualification)
      );
    },
    [qualificationRanking]
  );

  const sortQualificationsByRanking = useCallback(
    (qualifications: string[]) => {
      return [...qualifications].sort(
        (a, b) => qualificationRanking.indexOf(a) - qualificationRanking.indexOf(b)
      );
    },
    [qualificationRanking]
  );

  return { qualificationRanking, getHighestRankingQualification, sortQualificationsByRanking };
}
